export const SET_RELATION_TO_FACILITY = 'SET_RELATION_TO_FACILITY';
